import { ActionIcon, Tooltip } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useDeleteSurveyQuestion } from "../../api/survey";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";

const DeleteSurveyQuestionModal = ({ surveyId, questionId, ...props }) => {
  const { mutate } = useDeleteSurveyQuestion({ surveyId, questionId });
  const confirmDelete = useDeleteConfirm("question", mutate);

  return (
    <ActionIcon
      onClick={() => confirmDelete({})}
      color="red"
      variant="light"
      {...props}
    >
      <Tooltip label="Delete question">
        <IconTrash size={24} />
      </Tooltip>
    </ActionIcon>
  );
};

export default DeleteSurveyQuestionModal;
